import { render, staticRenderFns } from "./EventExpandPanel.vue?vue&type=template&id=1079ce8e&scoped=true"
import script from "./EventExpandPanel.vue?vue&type=script&lang=js"
export * from "./EventExpandPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1079ce8e",
  null
  
)

export default component.exports